import React, { useEffect, useState } from "react";
import { Modal, Button } from "react-bootstrap";

export default function EventPosterModal({ eventPoster }) {
  const [show, setShow] = useState(false);

  // Open after 2 seconds
  useEffect(() => {
    if (!eventPoster?.url) return;

    const timer = setTimeout(() => {
      setShow(true);
    }, 2000);

    return () => clearTimeout(timer);
  }, [eventPoster]);

  const handleClose = () => setShow(false);

  return (
    <Modal
      show={show}
      onHide={handleClose}
      centered
      backdrop="static"
      keyboard={false}
      style={{ zIndex: 9999 }}
      className="poster-modal"
    >
      <Modal.Body className="p-0">
        {/* Close button (top-right overlay) */}
        <Button
          variant="light"
          onClick={handleClose}
          style={{
            position: "absolute",
            top: "-10px",
            right: "-10px",
            borderRadius: "50%",
            padding: "4px 8px",
            zIndex: 10000,
            boxShadow: "0 2px 6px rgba(0,0,0,0.3)",
          }}
        >
          ✕
        </Button>

        <div className="d-flex">
          {/* IMAGE */}
          {eventPoster?.type === "image" && (
            <img
              src={eventPoster.url}
              alt="Advertisement"
              className="img-fluid rounded"
              style={{ maxHeight: "70vh", objectFit: "contain" }}
            />
          )}

          {/* VIDEO */}
          {eventPoster?.type === "video" && (
            <video
              width="100%"
              height="auto"
              autoPlay
              loop
              muted
              playsInline
              controls={false}
              preload="auto"
              style={{ maxHeight: "70vh", objectFit: "contain" }}
            >
              <source src={eventPoster.url} type="video/mp4" />
            </video>
          )}
        </div>
      </Modal.Body>
    </Modal>
  );
}
